export default __webpack_public_path__ + "static/media/random-chimp.7e847e41.gif";